module.exports = __webpack_public_path__ + "static/media/TransferList_001.c923cf1e.png";